var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"component":"Visualizer","detail":_vm.detail}},[_c('canvas',{ref:"canvas",style:(!_vm.maxWidth ? '' : 'width:100%')}),_vm._v(" "),(_vm.useFade)?_c('div',{staticClass:"bottom"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }